export const color = {
  // white Colors
  white: '#FFFFFF',

  // black Colors
  black: '#000000',

  // blue Colors
  blue25: '#F7F9FF',
  blue50: '#ECEEFF',
  blue100: '#E3E6FF',
  blue200: '#CACFFF',
  blue300: '#969EFF',
  blue400: '#6D79FF',
  blue500: '#4453FF',
  blue600: '#3E4CE8',
  blue700: '#303BB5',
  blue800: '#252E8C',
  blue900: '#1D236B',

  // grey Colors
  grey50: '#F6F6F9',
  grey100: '#EFEFF3',
  grey200: '#E4E4E8',
  grey300: '#D0D0D6',
  grey400: '#B3B3BB',
  grey500: '#909094',
  grey600: '#76767C',
  grey700: '#595959',
  grey800: '#3c3c3c',
  grey900: '#141414',

  // Sub colors 이전 label네이밍
  label01: '#8259FF',
  label02: '#E7DEFF',

  label03: '#2194FF',
  label04: '#D9ECFF',

  label05: '#02A9A9',
  label06: '#D0F5F5',

  label07: '#FF4E89',
  label08: '#FFE3EC',

  // Sub colors
  sub_red_100: '#FFDBDC',
  sub_red_500: '#E63639',

  sub_blue_100: '#D1DEFF',
  sub_blue_500: '#3A50E0',

  sub_cyan_100: '#D0F5F5',
  sub_cyan_500: '#02A9A9',

  sub_magenta_100: '#EFD3FF',
  sub_magenta_500: '#D93FDB',

  sub_orange_100: '#FFD9C6',
  sub_orange_500: '#FF6200',

  sub_lightBlue_100: '#D9ECFF',
  sub_lightBlue_500: '#2194FF',

  sub_green_100: '#D2FFD5',
  sub_green_500: '#02B50E',

  sub_pink_100: '#FFE3EC',
  sub_pink_500: '#FF4E89',

  sub_yellow_100: '#FFEFC7',
  sub_yellow_500: '#F99E00',

  sub_purple_100: '#E7DEFF',
  sub_purple_500: '#8259FF',

  // Gradient Colors
  gradient01: 'linear-gradient(92deg, #5D6AFF 0%, #9679FF 93.32%)',
  gradient02: 'linear-gradient(90deg, #96ACFF 0%, #C8BEFF 100%)',
  gradient03: 'linear-gradient(135deg, #EFF6FF 0%, #FAF5FF 100%)',

  // Opacity Colors
  opacity35: 'var(--opaticy35, rgba(60, 60, 60, 0.35))',
  opacity90: 'rgba(239, 239, 243, 0.9)',
} as const;
